var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c(_vm.titleTag,{tag:"component",staticClass:"title",class:_vm.titleClasses},[_vm._t("default")],2),_c('div',{staticClass:"buttons"},[_vm._t("actions")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }